import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  viewerController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$location',
    '$filter',
    'webApiSettings',
    'revisionService',
    '$state',
    'authService',
    '$window',
    'EFeatures',
    'IMG_TYPES',
    'TIFF_TYPES',
    'revisionListService',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $location,
      $filter,
      webApiSettings,
      revisionService,
      $state,
      authService,
      $window,
      EFeatures,
      IMG_TYPES,
      TIFF_TYPES,
      revisionListService
    ) {
      function initialize() {
        swal.fire({
          title: $filter('translate')('OPENING'),
          icon: 'info',
          showConfirmButton: false,
        });

        var errorHandler = (err) => {
          if (err.status_code === 404) {
            $state.go('revisionNotFound');
          }
          swal
            .fire({
              title: err.error,
              text: err.error_description,
              showConfirmButton: true,
            })
            .then(function () {
              if ($scope.guid !== undefined) {
                window.location = window.location.origin + '/#/login';
              }
            });
        };

        $scope.isWord = $scope.notWordExts.indexOf($scope.extension) === -1;

        var init = function () {
          if ($scope.guid !== undefined) {
            revisionService
              .findRevisionGuid($scope.guid, $scope.workflow)
              .then((revision) => {
                if (!$scope.validateViewPermission(revision)) {
                  $state.go('revisionNotFound');
                }

                revision.guid = $scope.guid;
                $scope.id = revision.id;
                $scope.currentDocument = revision;
                $scope.extension = revision.extension;
                $scope.isWord =
                  $scope.notWordExts.indexOf($scope.extension) === -1;
                $scope.title =
                  ($scope.workflow ? '' : revision.code + ' - ') +
                  revision.title +
                  '.' +
                  revision.extension;

                var valueExt = 13;

                const DateToday = new Date();
                $scope.Today = DateToday.toISOString().substring(0, 10);

                if (revision.PublicLinkDate !== undefined) {
                  if (revision.PublicLinkDate >= $scope.Today) {
                    $scope.extPdf.map(() => {
                      for (var i = 0; i < valueExt; i++) {
                        $scope.extPdf.forEach((e) => {
                          if (e[i] === revision.extension) {
                            if (e[i] === 'tiff' || e[i] === 'tif') {
                              swal.fire({
                                title: $filter('translate')('OPENING'),
                                icon: 'info',
                                showConfirmButton: false,
                              });
                              $scope.generateViewLink();
                            } else {
                              $scope.ext = e[i];
                              swal.fire({
                                title: $filter('translate')('OPENING'),
                                icon: 'info',
                                showConfirmButton: false,
                              });
                              $scope.generateViewLink();
                            }
                          }
                        });
                      }
                      if (revision.extension !== $scope.ext) {
                        swal.fire({
                          title:
                            'Não é possivel visualizar este formato de arquivo',
                          text: 'O link do arquivo foi expirado',
                          icon: 'info',
                          showConfirmButton: false,
                        });
                        $scope.download($scope.workflow);
                      }
                    });
                  } else {
                    swal.fire({
                      title: 'Não é possivel visualizar este arquivo',
                      text: 'O link do arquivo foi expirado',
                      icon: 'info',
                      showConfirmButton: false,
                    });
                  }
                } else {
                  $scope.generateViewLink();
                }
              })
              .catch((err) => {
                errorHandler(err);
              });
          } else {
            if ($scope.extension === undefined) {
              revisionService
                .findRevision($scope.id)
                .then(function (revision) {
                  if (!$scope.validateViewPermission(revision)) {
                    $state.go('revisionNotFound');
                  }

                  $scope.currentDocument = revision;

                  $scope.extension = revision.extension;
                  $scope.isWord =
                    $scope.notWordExts.indexOf($scope.extension) === -1;
                  $scope.title =
                    revision.code +
                    ' - ' +
                    revision.title +
                    '.' +
                    revision.extension;

                  var valueExt = 13;
                  var DateNow = new Date();
                  DateNow = DateNow.getTime();
                  var pbLinkDate = new Date(revision.PublicLinkDate);
                  pbLinkDate.getTime();

                  if (revision.PublicLinkDate !== undefined) {
                    if (pbLinkDate >= DateNow) {
                      $scope.extPdf.map(() => {
                        for (var i = 0; i < valueExt; i++) {
                          $scope.extPdf.forEach((e) => {
                            if (e[i] === revision.extension) {
                              if (e[i] === 'tiff' || e[i] === 'tif') {
                                swal.fire({
                                  title: $filter('translate')('OPENING'),
                                  icon: 'info',
                                  showConfirmButton: false,
                                });
                                $scope.generateViewLink();
                              } else {
                                $scope.ext = e[i];
                                swal.fire({
                                  title: $filter('translate')('OPENING'),
                                  icon: 'info',
                                  showConfirmButton: false,
                                });
                                $scope.generateViewLink();
                              }
                            }
                          });
                        }
                        if (revision.extension !== $scope.ext) {
                          swal.fire({
                            title:
                              'Não é possivel visualizar este formato de arquivo',
                            text: 'O link do arquivo foi expirado',
                            icon: 'info',
                            showConfirmButton: false,
                          });
                          $scope.download($scope.workflow);
                        }
                      });
                    } else {
                      swal.fire({
                        title: 'Não é possivel visualizar este arquivo',
                        text: 'O link do arquivo foi expirado',
                        icon: 'info',
                        showConfirmButton: false,
                      });
                    }
                  } else {
                    $scope.generateViewLink();
                  }
                })
                .catch((err) => errorHandler(err));
            } else {
              $scope.extension = $scope.extension.toLowerCase();
              $scope.generateViewLink();
              revisionService
                .findRevision($scope.id, $scope.workflow, $scope.isOldRevision)
                .then(function (revision) {
                  if (!$scope.validateViewPermission(revision)) {
                    $state.go('revisionNotFound');
                  }

                  $scope.currentDocument = revision;

                  $scope.title =
                    revision.code +
                    ' - ' +
                    revision.title +
                    '.' +
                    revision.extension;
                })
                .catch((err) => {
                  errorHandler(err);
                });
            }
          }
        };

        if ($scope.guid === undefined) {
          authService.loadUser().then(init, init);
        } else {
          //doc com link publico nao carrega usuario
          init();
        }
      }

      function validateViewPermission(revision) {
        if (authService.isAdmin() || revision.isPublic || $scope.workflow) {
          return true;
        }

        //Pega as features da pasta ou do documento quando estiver no favoritos, checkout ou pesquisa
        var features =
          revision.features !== null && revision.features !== undefined
            ? revision.features
            : [];

        var canView = features.indexOf(EFeatures.VIEW_DOCUMENT) > -1;
        var canDownload = features.indexOf(EFeatures.DOWNLOAD) > -1;
        var canPrint = features.indexOf(EFeatures.PRINT) > -1;

        if (canView || canDownload || canPrint) {
          return true;
        } else {
          return false;
        }
      }

      function close() {
        $window.close();
      }

      function download(inWorkflow) {
        var doc = $scope.currentDocument;
        var idDownload =
          (doc.isPublic || inWorkflow) && doc.guid !== undefined
            ? doc.guid
            : doc.id;
        revisionListService.download(idDownload, doc.isPublic, inWorkflow).then(
          function () {},
          function () {}
        );
      }

      function print() {
        document.getElementById('viewer').contentWindow.print();
      }

      function generateViewLink() {
        let url = null;
        let signers = [];
        $scope.imageTypes = IMG_TYPES;
        $scope.tiffTypes = TIFF_TYPES;

        swal.fire({
          title: $filter('translate')('OPENING'),
          icon: 'info',
          showConfirmButton: false,
        });

        var ext = $scope.extension.toLowerCase();
        if (ext.endsWith('p7s')) {
          ext = ext.split('.')[0];
        }

        var isPublic = $scope.guid !== undefined;
        var dataUri = [];
        var idToLoad = isPublic ? $scope.guid : $scope.id;
        if (isPublic) {
          if (ext !== 'tif') {
            revisionService
              .findRevisionGuid(idToLoad, $scope.inWorkflow)
              .then(function (data) {
                dataUri = {
                  revision: {
                    id: data.id,
                    idCompany: data.idCompany,
                    isHistory: data.isHistory,
                    extension: data.extension.toLowerCase(),
                    title: data.title,
                    server: webApiSettings.viewerServer,
                    rowGuid: data.guid,
                    pageCount: data.numberOfPages,
                    userId: authService.user.id,
                  },
                  token: authService.authentication.token,
                  webApiUrl: webApiSettings.apiServiceBaseUri,
                  detailsCompany: webApiSettings.detailsCompany,
                  infos: {
                    canPrint: true,
                    canDownload: true,
                    urlBase: window.location.href,
                  },
                  signers: {},
                };

                if (data.isSigned) {
                  revisionListService
                    .loadSignersInfo(
                      !data.isHistory ? data.id : data.idRevisionHistory,
                      data.extension,
                      data.hasWorkflow,
                      data.isHistory
                    )
                    .then((infoSigners) => {
                      signers = infoSigners;
                    })
                    .catch(() => {})
                    .finally(function () {
                      if (signers.length !== undefined) {
                        dataUri['signers'] = signers;
                      }

                      if (data.idStatus === 3) {
                        if (data.idRevisionHistory !== undefined) {
                          dataUri.revision.isOldRevision = true;
                          dataUri.revision.id = data.idRevisionHistory;
                        }
                        var encoded = encodeURIComponent(
                          JSON.stringify(dataUri)
                        );
                        url = webApiSettings.viewerBaseUri + '#/' + encoded;
                      } else {
                        var encoded = encodeURIComponent(
                          JSON.stringify(dataUri)
                        );
                        url = webApiSettings.viewerBaseUri + '#/' + encoded;
                      }

                      $scope.openView(url);
                    });
                } else {
                  if (data.idStatus === 3) {
                    if (data.idRevisionHistory !== undefined) {
                      dataUri.revision.isOldRevision = true;
                      dataUri.revision.id = data.idRevisionHistory;
                    }
                    var encoded = encodeURIComponent(JSON.stringify(dataUri));
                    url = webApiSettings.viewerBaseUri + '#/' + encoded;
                  } else {
                    var encoded = encodeURIComponent(JSON.stringify(dataUri));
                    url = webApiSettings.viewerBaseUri + '#/' + encoded;
                  }

                  $scope.openView(url);
                }
              })
              .catch(() => {
                $scope.viewer = 'notfound';
                swal.close();
              });
          } else if (ext === 'tif') {
            revisionService
              .imageViewLink(
                $scope.id,
                $scope.inWorkflow,
                isPublic,
                $scope.isOldRevision
              )
              .then((data) => {
                $scope.openView(data);
              });
          }
        } else if ($scope.isOldRevision) {
          revisionService
            .findRevision($scope.id, $scope.workflow, $scope.isOldRevision)
            .then(function (revision) {
              dataUri = {
                revision: {
                  Id: revision.id,
                  IdCompany: revision.idCompany,
                  IsHistory: $scope.isOldRevision,
                  extension: revision.extension.toLowerCase(),
                  Title: revision.title,
                  Server: webApiSettings.viewerServer,
                  RowGuid: null,
                  userId: authService.user.id
                },
                token: authService.authentication.token,
                webApiUrl: webApiSettings.apiServiceBaseUri,
                detailsCompany: webApiSettings.detailsCompany,
                infos: {
                  canPrint: null,
                  canDownload: null,
                  urlBase: window.location.href,
                },
                signers: [],
              };

              var encoded = encodeURIComponent(JSON.stringify(dataUri));
              url = webApiSettings.viewerBaseUri + '#/' + encoded;

              $scope.openView(url);
            });
        }
      }

      function openView(url) {
        var isPublic = $scope.guid !== undefined;
        if (isPublic) {
          window.open(url, '_self');
        }
        else {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      }

      function run() {
        try {
          $scope.token = $state.params.t;
          $scope.id = $state.params.rev;
          $scope.extension = $state.params.ext;
          $scope.workflow = $state.params.w === 'true' ? true : false;
          $scope.isOldRevision = $state.params.o === 'true' ? true : false;
          $scope.guid = $state.params.guid;

          if ($scope.token !== undefined) {
            authService.authentication.token = $scope.token;
            authService.authentication.isAuth = true;
            authService.storeAuthData();
            $location.url('/view/' + $scope.id);
          }

          $scope.isWord = false;
          $scope.notWordExts = [
            'ppt',
            'ppt.p7s',
            'pptx',
            'pptx.p7s',
            'xls',
            'xls.p7s',
            'xlsx',
            'xlsx.p7s',
          ];

          $rootScope.onLogin = false;
          $scope.isAuth = authService.authentication.isAuth;

          $scope.extPdf = [
            {
              0: 'doc',
              1: 'docx',
              2: 'ppt',
              3: 'pptx',
              4: 'doc',
              5: 'txt',
              6: 'xls',
              7: 'xlsx',
              8: 'gif',
              9: 'jpg',
              10: 'jpeg',
              11: 'png',
              12: 'pdf',
              13: 'tiff',
              14: 'tif',
              15: 'mp4',
              16: 'webm',
              17: 'ogg',
            },
          ];

          $scope.viewer = 'owa';
          $scope.viewUrl = '';

          $scope.currentDocument = null;

          $scope.initialize = logWrapper(
            initialize,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validateViewPermission = logWrapper(
            validateViewPermission,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.close = logWrapper(
            close,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.download = logWrapper(
            download,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.print = logWrapper(
            print,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.generateViewLink = logWrapper(
            generateViewLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.openView = logWrapper(
            openView,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
